<template>
  <div class="descriptionOfGoods">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.Loading_Quantity') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Loading_Quantity') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.lmediaGates"
          :otherData="{
            mediaName: '工厂大门',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaGates',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Packed') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.lmediaPacked"
          :otherData="{
            mediaName: '大货箱堆',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaPacked',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Unpacked') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.lmediaUnpacked"
          :otherData="{
            mediaName: '未入箱成品',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaUnpacked',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Semi_finished') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.lmediaSemi"
          :otherData="{
            mediaName: '半成品',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaSemi',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table1"
        :columns="columns"
        :dataSource="data"
        bordered
        :pagination="false"
        rowKey="id"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
// const columns =
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.LoadingReport.Completed'),
          children: [
            {
              title: this.$tc('lang.LoadingReport.Quantity_pcs'),
              dataIndex: 'goodsComquantity',
              key: 'goodsComquantity',
            },
            {
              title: this.$tc('lang.LoadingReport.Cartons_CTN'),
              dataIndex: 'goodsComcarton',
              key: 'goodsComcarton',
            },
          ],
        },
        {
          title: this.$tc('lang.LoadingReport.Uncompleted'),
          children: [
            {
              title: this.$tc('lang.LoadingReport.Quantity_pcs1'),
              dataIndex: 'goodsUncomquantity',
              key: 'goodsUncomquantity',
            },
            {
              title: this.$tc('lang.LoadingReport.Cartons_CTN1'),
              dataIndex: 'goodsUncomcarton',
              key: 'goodsUncomcarton',
            },
          ],
        },
      ],
      data: [],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      id: this.$route.query.id,
    };
  },
  components: {
    showImg,
  },
  computed: {
    supervisionDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.supervisionDetails),
        );
      },
    },
    descriptionOfGoods: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.supervisionImgList.descriptionOfGoods,
          ),
        );
      },
    },
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      this.$http
        .post('/hzwmj/loadig-goods/getLoadigGoods', {
          lreoprtId: this.supervisionDetails.lreoprtId,
        })
        .then(data => {
          if (data) {
            this.data = [data];
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
  },
};
</script>
<style lang="less">
.descriptionOfGoods {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          // border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
